/* global chrome */

import { cacheManager } from '../utils/CacheManager.js';
export const DEMO_ACCOUNT_SESSION_KEY = 1373184313;
export const DEMO_ACCOUNT_SESSION_EMAIL = 'demo@comprehendpt.com';
export const INVALID_DEMO_ENDPOINTS = [
  '/user/setDefaultConfigId',
  '/config/new',
  '/config/duplicate',
  '/template/new',
  '/template/emrQuery',
  '/config/editBulk',
  '/config/edit',
  '/config/genInstruction',
  '/config/reorder',
  '/config/delete',
  '/config/getBuilderTemplate',
  '/reset/password',
  '/reset/email',
  '/conversation/new',
  '/conversation/delete',
  '/conversation/edit',
  '/conversation/audio/add',
  '/conversation/audio/requesturl',
  '/conversation/audio/addfromurl',
  '/conversation/comprehend',
  '/conversation/questions',
  '/patient/new',
  '/patient/delete',
];
export const SUBSCRIPTION_REQUIRED_ENDPOINTS = [
  '/config/new',
  '/config/feedback',
  '/config/edit/build',
  '/conversation/new',
  '/conversation/audio/add',
  '/conversation/audio/requesturl',
  '/conversation/audio/addfromurl',
  '/conversation/comprehend',
];

// Function to store credentials
export function storeSessionKey(sessionKey) {
  try {
    // Use sessionStorage or localStorage based on your requirements
    sessionStorage.setItem('sessionKey', sessionKey);
    //   updateStripePaymentTable(sessionKey);
  } catch (error) {
    console.error('Error storing sessionKey:', error);
  }
}

// Function to store credentials
export function storeSessionEmail(sessionEmail) {
  try {
    // Use sessionStorage or localStorage based on your requirements
    sessionStorage.setItem('sessionEmail', sessionEmail);

  } catch (error) {
    console.error('Error storing sessionEmail:', error);
  }
}

// Function to store credentials
export function storeLocalData(sessionData, isEmail = false) {
  try {
    // Use sessionStorage or localStorage based on your requirements
    if (isEmail) {
      localStorage.setItem('sessionEmail', sessionData);
    } else {
      localStorage.setItem('sessionKey', sessionData);
    }

  } catch (error) {
    console.error('Error storing sessionKey:', error);
  }
}

export function removeSessionKey(apiClient) {
  try {
    // End the session on the server too, or a copied key outlives the logout.
    // Fire and forget: signing out never waits on, or fails with, the network.
    apiClient.logout?.();

    // Use sessionStorage or localStorage based on your requirements
    sessionStorage.removeItem('sessionKey');
    localStorage.removeItem('sessionKey');
    // Remove email from sessionStorage and localStorage
    sessionStorage.removeItem('sessionEmail');
    localStorage.removeItem('sessionEmail');
    sessionStorage.removeItem('gaUserInitialized');
    sessionStorage.removeItem('deviceData');

    cacheManager.clear();
    apiClient.reset();
  } catch (error) {
    console.error('Error removing sessionKey:', error);
  }
}

// Function to retrieve the stored credentials
export function getSessionKey() {
  try {
    // Check if we are in Demo
    if (decodeHash(window.location.hash.substring(1)) === 'demo') {
      console.log('Demo Mode Activated');
      storeSessionKey(DEMO_ACCOUNT_SESSION_KEY);
      return DEMO_ACCOUNT_SESSION_KEY;
    }

    // try the sessionStore first then localStorage
    var sessionKey = sessionStorage.getItem('sessionKey');
    if (!sessionKey || isNaN(sessionKey)) {
      sessionKey = localStorage.getItem('sessionKey');
    }
    // updateStripePaymentTable(sessionKey);
    // convert the sessionKey to int
    sessionKey = parseInt(sessionKey);
    if (isNaN(sessionKey)) {
      return null;
    }
    return sessionKey;
  } catch (error) {
    console.error('Error retrieving credentials:', error);
    return null;
  }
}

// Function to retrieve the stored email
export function getSessionEmail() {
  try {
    // Check if we are in Demo
    if (decodeHash(window.location.hash.substring(1)) === 'demo') {
      storeSessionKey(DEMO_ACCOUNT_SESSION_EMAIL);
      return DEMO_ACCOUNT_SESSION_EMAIL;
    }

    // try sessionStorage first, then localStorage
    var email = sessionStorage.getItem('sessionEmail');
    if (!email) {
      email = localStorage.getItem('sessionEmail');
    }
    if (!email) {
      return null;
    }
    return email;
  } catch (error) {
    console.error('Error retrieving email:', error);
    return null;
  }
}

export function decodeHash(hashStr) {
  try {
    // decode the hash string to remove %20 and other special characters
    return decodeURIComponent(hashStr);
  } catch (e) {
    // if there's an error during decoding, return the original string
    console.error('Error decoding the hash:', e);
    return hashStr;
  }
}

export function gradualType(text, setFunc, intervalTime) {
  return new Promise((resolve, reject) => {
    if (text === null) {
      reject('Text is null');
      return;
    }
    let i = 0;
    let interval = setInterval(() => {
      if (i < text.length) {
        setFunc(text.substring(0, i + 1));
        i++;
      } else {
        clearInterval(interval);
        resolve();
      }
    }, intervalTime);
  });
}
